import React from 'react';
import {
  GuestOrderingStatus,
  isAcceptingGuestOrders,
  isGuestOrderingOffline,
} from '../../../utils/guestOrdering';
import './GuestOrderingBanner.css';

interface GuestOrderingBannerProps {
  status?: GuestOrderingStatus | null;
  compact?: boolean;
}

const GuestOrderingBanner: React.FC<GuestOrderingBannerProps> = ({ status, compact = false }) => {
  if (isAcceptingGuestOrders(status)) return null;
  const offline = isGuestOrderingOffline(status);
  const title = offline ? 'Offline' : 'Closed';
  const detail = offline ? 'Orders paused' : 'Outside opening hours';
  const className = [
    'guest-ordering-banner',
    offline ? 'guest-ordering-banner--offline' : 'guest-ordering-banner--hours',
    compact ? 'guest-ordering-banner--compact' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={className} role="status">
      <span className="guest-ordering-banner__dot" aria-hidden />
      <p className="guest-ordering-banner__text">
        <strong>{title}</strong>
        <span className="guest-ordering-banner__sep" aria-hidden>
          ·
        </span>
        <span>{detail}</span>
        {!compact && <span className="guest-ordering-banner__extra"> — you can still browse the menu</span>}
      </p>
    </div>
  );
};

export default GuestOrderingBanner;
